import { SyncConfigTypes } from './actionTypes';

export const getSyncConfiguration = (data: any) => ({
  type: SyncConfigTypes.GET_SYNC_OPERATIONS,
  payload: data,
});

export const getSyncConfigurationSuccess = (data: any) => ({
  type: SyncConfigTypes.GET_SYNC_OPERATIONS_SUCCESS,
  payload: data,
});

export const getSyncConfigurationFail = (error: any) => ({
  type: SyncConfigTypes.GET_SYNC_OPERATIONS_FAIL,
  payload: error,
});

export const addSyncConfiguration = (data: any) => {
  return {
    type: SyncConfigTypes.ADD_SYNC_OPERATIONS,
    payload: data,
  };
};
export const addSyncConfigurationSucces = (data: any) => {
  return {
    type: SyncConfigTypes.ADD_SYNC_OPERATIONS_SUCCESS,
    payload: data,
  };
};
export const addSyncConfigurationFail = (data: any) => {
  return {
    type: SyncConfigTypes.ADD_SYNC_OPERATIONS_FAIL,
    payload: data,
  };
};

export const deleteSyncConfiguration = (id: any) => {
  return {
    type: SyncConfigTypes.DELETE_SYNC_OPERATIONS,
    payload: { id },
  };
};

export const updateSyncConfiguration = (data: any) => {
  return {
    type: SyncConfigTypes.UPDATE_SYNC_OPERATIONS,
    payload: data,
  };
};
